import { Box, Tooltip, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const CustomDocumentIndicatiors = ({ selectedRow }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        py: 1,
        px: 1,
        borderBottom: "1px solid #e0e0e0", // Add a subtle divider below
      }}
    >
      {/* Notarized Status */}
      {selectedRow?.document?.actions?.notarize && (
        <Tooltip title="Document Notarized">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {selectedRow?.notarized ? (
              <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
            ) : (
              // Default case: red cancel icon
              (<CancelIcon color="error" sx={{ fontSize: 30 }} />)
            )}
            <Typography
              variant="caption"
              color="textSecondary"
              fontWeight="bold"
            >
              Notarized
            </Typography>
          </Box>
        </Tooltip>
      )}
      {/* Recorded Status */}
      {selectedRow?.document?.actions?.record && (
        <Tooltip title="Document Recorded">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {selectedRow?.processing_permit?.recording?.recorded ? (
              <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
            ) : (
              <CancelIcon color="error" sx={{ fontSize: 30 }} />
            )}
            <Typography
              variant="caption"
              color="textSecondary"
              fontWeight="bold"
            >
              Recorded
            </Typography>
          </Box>
        </Tooltip>
      )}
      {/* Downloaded Status */}
      <Tooltip title="Document Downloaded">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {selectedRow?.document?.downloaded ? (
            <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />
          ) : (
            <CancelIcon color="error" sx={{ fontSize: 30 }} />
          )}
          <Typography variant="caption" color="textSecondary" fontWeight="bold">
            Downloaded
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default CustomDocumentIndicatiors;
